import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';

import {
  InspectionAssemblyItem,
  InspectionAssemblyItemTitle,
} from '../types/inspection-assembly-item';
import { InspectionMeasureAssemblyItemDto } from '../dto/inspection-measure-assembly-item.dto';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteInspectionAssemblyItemService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }

  urlRoute = `${API_BASE_URL}/inspection/assembly-item`;

  getItemsByAssemblyTitle(
    assemblyTitle: string
  ): Observable<InspectionAssemblyItemTitle[]> {
    return this.http.get<InspectionAssemblyItemTitle[]>(
      `${this.urlRoute}/title/${assemblyTitle}`
    );
  }

  getItemsMeasures(
    body?: { department: string } | { transactionType: string }
  ): Observable<InspectionAssemblyItem[]> {
    return this.http.get<InspectionAssemblyItem[]>(`${this.urlRoute}`, {
      params: {
        ...body,
      },
    });
  }

  getItemMeasure(id: number): Observable<InspectionAssemblyItem> {
    return this.http.get<InspectionAssemblyItem>(`${this.urlRoute}/${id}`);
  }

  getMeasureByName(itemName: string, workOrderId?: number | string): Observable<InspectionAssemblyItem> {
    let url =  `${this.urlRoute}/measure?itemName=${itemName}`;
    if (workOrderId) {
      url += `&workOrderId=${workOrderId}`;
    }
    return this.http.get<InspectionAssemblyItem>(url);
  }

  addItem(
    body: InspectionMeasureAssemblyItemDto['create']['body']
  ): Observable<InspectionAssemblyItem> {
    return this.http.post<InspectionAssemblyItem>(`${this.urlRoute}`, body);
  }

  updateItemMeasure(
    id: number,
    body: InspectionMeasureAssemblyItemDto['update']['body']
  ): Observable<InspectionAssemblyItem> {
    return this.http.patch<InspectionAssemblyItem>(
      `${this.urlRoute}/${id}`,
      body
    );
  }

  // updateItemsMeasure(body: ItemMeasureApiDto['import']): Observable<any> {
  //   return this.http.patch<any>(`${this.urlRoute}`, body);
  // }

  importItemsMeasure(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.urlRoute}/import`, formData);
  }

  deleteItemMeasure(id: number): Observable<any> {
    return this.http.delete<any>(`${this.urlRoute}/${id}`);
  }
}
